export default __webpack_public_path__ + "static/media/CUSTOME-SHOWER-HOT-MOP.461319e3.jpg";